import React from 'react';

import { CustomerCarts } from '../../Types';
import { formatPrice } from '../../FormatPrice';

import '../Total.scss';

interface Props {
    carts: CustomerCarts;
}

const Total: React.FunctionComponent<Props> = (props) => {
    const getTotal = () => {
        let total = 0;

        Object.values(props.carts).map((cart) => {
            total += cart.items.reduce((accumulator, item) => accumulator + item.priceInCents * item.quantity, 0);
        });

        return total / 100;
    };

    const cartWithItems = Object.values(props.carts).find((cart) => cart.items.length > 0);
    const countryCode = cartWithItems ? cartWithItems.items[0].countryCode : 'AT';

    return (
        <div className="cart__total">
            <div>
                <strong>Zwischensumme</strong>
                <div className="total__disclaimer">inkl. MwSt zzgl. Versand</div>
            </div>
            <div className="cart__sum">
                <strong className="total__price">{formatPrice(countryCode, getTotal())}</strong>
            </div>
        </div>
    );
};

export default Total;
